import {css, SerializedStyles, Theme} from "@emotion/react";

export const globalReset = (theme: Theme): SerializedStyles => css`
  html {
    font-size: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 1em;
    font-weight: inherit;
    margin: 0;
  }

  body {
    ${theme.brandFont};
    margin: 0;
    padding: 0;
    text-size-adjust: 100%;
  }

  a {
    text-decoration: none;
    border-bottom: none;
    color: inherit;
  }

  img {
    max-width: 100%;
  }

  a img {
    border: 0;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 0;
    padding: 0;
  }

  label {
    cursor: pointer;
    display: block;
  }

  button,
  input,
  select {
    font-size: 1em;
  }

  button {
    cursor: pointer;
  }

  input[type="submit"] {
    margin: 0;
    padding: 0;
    border: 0;
  }

  dt,
  dl,
  dd {
    margin: 0;
    padding: 0;
  }

  hr {
    height: 2px;
    background: #cbcaca;
    margin: 0;
    padding: 0;
    border: none;
  }

  p {
    margin: 0;
  }
`;
